import { AngryIcon, HappyIcon, SedIcon } from 'assets'
import { JoysIcon, NeutralIcon } from 'assets/icon/emotion-icon'
import { emotionIcon, emotionType } from 'constant/const'

export const getEmotionIcon = (type, eType) => {
   const emotion = emotionIcon.find((item) => item.name?.toLowerCase() === type?.toLowerCase())
   // return emotion ? emotion.icon : <JoysIcon />

   if (emotion) {
      return emotion.icon
   } else if (eType === 'positive') {
      return <JoysIcon />
   } else if (eType === 'negative') {
      return <AngryIcon />
   } else {
      return <NeutralIcon /> // Default if no match and type is not specified
   }
}

export const getEmotionFColor = (type, eType) => {
   const emotion = emotionIcon.find((item) => item.name?.toLowerCase() === type?.toLowerCase())
   if (emotion) {
      return emotion.firstColor
   } else if (eType === 'positive') {
      return '#F6D365'
   } else if (eType === 'negative') {
      return '#8B0000'
   } else {
      return null // Default if no match and type is not specified
   }
}

export const getEmotionSColor = (type, eType) => {
   const emotion = emotionIcon.find((item) => item.name?.toLowerCase() === type?.toLowerCase())
   if (emotion) {
      return emotion.secondColor
   } else if (eType === 'positive') {
      return '#E09EFF'
   } else if (eType === 'negative') {
      return '#B22222'
   } else {
      return null // Default if no match and type is not specified
   }
}

export const getEmotionSvgIcon = (type, eType) => {
   const emotion = emotionIcon.find((item) => item.name?.toLowerCase() === type?.toLowerCase())
   // return emotion ? emotion.icon : <JoysIcon />

   if (emotion) {
      return emotion.svgIcon
   } else if (eType === 'positive') {
      return `<svg
            width="30"
            height="22"
            viewBox="0 0 30 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
               d="M29.7283 11.2037C29.6008 10.9796 29.4298 10.7832 29.2255 10.6259C29.0212 10.4686 28.7876 10.3535 28.5383 10.2875C27.634 10.0548 26.6996 9.96123 25.7671 10.01C26.2671 7.52875 25.8921 5.56625 25.5171 4.4025C25.3641 3.92452 25.0388 3.52054 24.6044 3.26917C24.1701 3.01779 23.6577 2.93699 23.1671 3.0425C21.8951 3.32579 20.6856 3.83923 19.5983 4.5575C18.802 2.9308 17.6426 1.50881 16.2096 0.40125C15.8623 0.140794 15.4399 0 15.0058 0C14.5717 0 14.1494 0.140794 13.8021 0.40125C12.3668 1.5081 11.2052 2.93015 10.4071 4.5575C9.31977 3.83923 8.1103 3.32579 6.83833 3.0425C6.34781 2.93646 5.83538 3.01704 5.40108 3.26851C4.96678 3.51999 4.6418 3.92429 4.48958 4.4025C4.11458 5.56625 3.73958 7.5275 4.23208 10.01C3.29959 9.96123 2.36512 10.0548 1.46083 10.2875C1.21156 10.3535 0.977947 10.4686 0.77363 10.6259C0.569312 10.7832 0.398384 10.9796 0.270827 11.2037C0.1375 11.4332 0.0511539 11.6868 0.0168173 11.9499C-0.0175192 12.213 0.000840336 12.4803 0.0708268 12.7362C0.494577 14.3088 1.79583 17.2975 5.73708 19.6525C9.67833 22.0075 13.1408 22 15.0058 22C16.8708 22 20.3396 22 24.2558 19.6525C28.1971 17.2975 29.4983 14.3088 29.9221 12.7362C29.993 12.4807 30.0124 12.2136 29.9791 11.9505C29.9459 11.6874 29.8606 11.4336 29.7283 11.2037ZM6.76208 17.9363C3.43333 15.9463 2.35208 13.5062 1.99958 12.2125C2.91926 11.9854 3.8738 11.9358 4.81208 12.0662C5.12532 12.9053 5.5079 13.7169 5.95583 14.4925C7.05565 16.3887 8.49652 18.0652 10.2058 19.4375C8.99714 19.09 7.83933 18.5853 6.76208 17.9363ZM14.9996 19.8C13.8333 18.9325 10.9996 16.2712 10.9996 10.8962C10.9996 5.5875 13.7971 2.905 14.9996 2C16.2021 2.9075 18.9996 5.59 18.9996 10.8988C18.9996 16.2712 16.1658 18.9325 14.9996 19.8ZM27.9996 12.215C27.6533 13.495 26.5746 15.9413 23.2383 17.9363C22.161 18.5848 21.0032 19.0891 19.7946 19.4363C21.5039 18.0639 22.9448 16.3874 24.0446 14.4912C24.4925 13.7156 24.8751 12.9041 25.1883 12.065C26.1264 11.9357 27.0804 11.9862 27.9996 12.2138V12.215Z"
               fill="url(#paint0_linear_668_16346)"
            />
            <defs>
               <linearGradient
                  id="paint0_linear_668_16346"
                  x1="1.78784e-06"
                  y1="22"
                  x2="30.3403"
                  y2="0.487041"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#F6D365" />
                  <stop offset="1" stop-color="#E09EFF" />
               </linearGradient>
            </defs>
         </svg>`
   } else if (eType === 'negative') {
      return `<svg
            width="22"
            height="30"
            viewBox="0 0 22 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
               d="M21.7322 14.6816L7.73215 29.6816C7.58379 29.84 7.38796 29.9457 7.1742 29.983C6.96045 30.0203 6.74037 29.987 6.54718 29.8882C6.354 29.7895 6.19818 29.6305 6.10324 29.4354C6.00831 29.2403 5.97941 29.0196 6.0209 28.8066L7.8534 19.6404L0.64965 16.9354C0.49494 16.8775 0.356974 16.7822 0.248079 16.658C0.139184 16.5338 0.062751 16.3846 0.0256088 16.2236C-0.0115334 16.0627 -0.00822786 15.895 0.0352299 15.7357C0.0786877 15.5763 0.160944 15.4302 0.27465 15.3104L14.2747 0.310381C14.423 0.152051 14.6188 0.0462705 14.8326 0.00900269C15.0464 -0.0282652 15.2664 0.0050017 15.4596 0.103783C15.6528 0.202565 15.8086 0.361501 15.9036 0.556609C15.9985 0.751716 16.0274 0.972408 15.9859 1.18538L14.1484 10.3616L21.3521 13.0629C21.5057 13.1211 21.6426 13.2163 21.7506 13.34C21.8587 13.4637 21.9346 13.6122 21.9717 13.7722C22.0087 13.9322 22.0058 14.0989 21.9632 14.2575C21.9205 14.4161 21.8395 14.5618 21.7271 14.6816H21.7322Z"
               fill="url(#paint0_linear_668_26069)"
            />
            <defs>
               <linearGradient
                  id="paint0_linear_668_26069"
                  x1="-6.55575e-07"
                  y1="29.9979"
                  x2="29.1934"
                  y2="18.8668"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#FF4500" />
                  <stop offset="1" stop-color="#B22222" />
               </linearGradient>
            </defs>
         </svg>`
   } else {
      return `<svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
               d="M26 13C26 20.0788 20.0775 26 13 26C11.663 26.0007 10.3339 25.7945 9.06 25.3888C8.97795 25.3629 8.90396 25.3163 8.84518 25.2535C8.7864 25.1907 8.74482 25.1138 8.72446 25.0302C8.70409 24.9466 8.70564 24.8592 8.72895 24.7764C8.75226 24.6936 8.79653 24.6182 8.8575 24.5575L24.5575 8.85625C24.6182 8.79529 24.6936 8.75101 24.7764 8.7277C24.8592 8.70439 24.9466 8.70285 25.0302 8.72321C25.1138 8.74357 25.1907 8.78515 25.2535 8.84393C25.3163 8.90271 25.3629 8.9767 25.3888 9.05875C25.7946 10.3331 26.0008 11.6626 26 13ZM23.98 6.04875C23.7458 5.67947 23.493 5.32235 23.2225 4.97875C23.1786 4.92286 23.1232 4.87698 23.0602 4.84417C22.9971 4.81136 22.9278 4.79236 22.8568 4.78846C22.7859 4.78456 22.7149 4.79583 22.6486 4.82153C22.5823 4.84723 22.5223 4.88677 22.4725 4.9375L4.9375 22.4775C4.88677 22.5273 4.84723 22.5873 4.82153 22.6536C4.79583 22.7199 4.78455 22.7909 4.78846 22.8618C4.79236 22.9328 4.81135 23.0021 4.84417 23.0652C4.87698 23.1282 4.92286 23.1836 4.97875 23.2275C5.32234 23.498 5.67947 23.7508 6.04875 23.985C6.14493 24.047 6.25945 24.074 6.37319 24.0618C6.48693 24.0495 6.59302 23.9986 6.67375 23.9175L23.9125 6.67375C23.9936 6.59302 24.0445 6.48693 24.0568 6.37319C24.069 6.25945 24.042 6.14493 23.98 6.04875ZM21.0213 2.7775C20.6777 2.50702 20.3205 2.2542 19.9513 2.02C19.8551 1.95805 19.7406 1.93096 19.6268 1.94325C19.5131 1.95553 19.407 2.00645 19.3263 2.0875L2.0875 19.3275C2.00645 19.4082 1.95553 19.5143 1.94325 19.6281C1.93096 19.7418 1.95805 19.8563 2.02 19.9525C2.2542 20.3218 2.50702 20.6789 2.7775 21.0225C2.82142 21.0784 2.87676 21.1243 2.93981 21.1571C3.00287 21.1899 3.0722 21.2089 3.14317 21.2128C3.21415 21.2167 3.28514 21.2054 3.35141 21.1797C3.41768 21.154 3.47772 21.1145 3.5275 21.0638L21.0625 3.5225C21.1124 3.47277 21.1512 3.41305 21.1764 3.34726C21.2016 3.28147 21.2126 3.2111 21.2087 3.14076C21.2048 3.07042 21.1861 3.0017 21.1538 2.9391C21.1215 2.8765 21.0763 2.82143 21.0213 2.7775ZM16.9413 0.611253C15.6669 0.205343 14.3374 -0.000848548 13 2.62451e-06C5.9225 2.62451e-06 2.38306e-06 5.92125 2.38306e-06 13C-0.000808612 14.3374 0.205382 15.6669 0.611252 16.9413C0.637102 17.0233 0.683685 17.0973 0.746495 17.1561C0.809306 17.2149 0.88622 17.2564 0.969801 17.2768C1.05338 17.2972 1.1408 17.2956 1.22361 17.2723C1.30642 17.249 1.38181 17.2047 1.4425 17.1438L17.1438 1.4425C17.2047 1.38181 17.249 1.30642 17.2723 1.22361C17.2956 1.1408 17.2972 1.05338 17.2768 0.969801C17.2564 0.88622 17.2149 0.809306 17.1561 0.746495C17.0973 0.683685 17.0233 0.637103 16.9413 0.611253Z"
               fill="url(#paint0_linear_668_29315)"
            />
            <defs>
               <linearGradient
                  id="paint0_linear_668_29315"
                  x1="26"
                  y1="7.7486e-07"
                  x2="-5.108"
                  y2="16.1781"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#B0C4DE" />
                  <stop offset="1" stop-color="#DCDCDC" />
               </linearGradient>
            </defs>
         </svg>`

      // Default if no match and type is not specified
   }
}
